export const INACTIVITY_TIMEOUT_MS = 15 * 60 * 1000;
export const LAST_ACTIVITY_KEY = "lastActivity";

export const getLastActivity = () => {
  const timestamp = Number(localStorage.getItem(LAST_ACTIVITY_KEY));
  return Number.isFinite(timestamp) && timestamp > 0 && timestamp <= Date.now()
    ? timestamp
    : null;
};

export const clearStoredSession = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("UserName");
  localStorage.removeItem(LAST_ACTIVITY_KEY);
};
